module.exports = __webpack_public_path__ + "static/media/notification_off.f822147c.svg";